import { DASH, formatHours, formatMoney } from "./format";
import type { Totals } from "./types";

export interface SummaryBarProps {
  original: Totals | null;
  change: Totals | null;
  currency: string;
  showMargin?: boolean;
}

export const margin = (t: Totals) =>
  t.revenue === 0 ? null : ((t.revenue - t.cost) / t.revenue) * 100;

const pct = (n: number | null) => (n === null ? DASH : `${n.toFixed(1)}%`);

const SummaryBar = ({
  original,
  change,
  currency,
  showMargin = true,
}: SummaryBarProps) => {
  const total =
    original && change
      ? {
          hours: original.hours + change.hours,
          revenue: original.revenue + change.revenue,
          cost: original.cost + change.cost,
        }
      : null;

  const cell = (label: string, money: string, hours: string) => (
    <div className="changeOrderSummaryCell">
      <div className="changeOrderSummaryLabel">{label}</div>
      <div className="changeOrderSummaryValue">{money}</div>
      <div className="changeOrderSummaryHours">{hours}</div>
    </div>
  );

  return (
    <div className="changeOrderSummaryBar" data-testid="change-order-summary">
      {cell(
        "Original as signed",
        original ? formatMoney(original.revenue, currency) : DASH,
        original ? `${formatHours(original.hours)} hrs` : ""
      )}
      {cell(
        "This change",
        change ? formatMoney(change.revenue, currency, true) : DASH,
        change ? `+${formatHours(change.hours)} hrs` : ""
      )}
      {cell(
        "Project with this change",
        total ? formatMoney(total.revenue, currency) : DASH,
        total ? `${formatHours(total.hours)} hrs` : ""
      )}
      {showMargin && (
        <div className="changeOrderSummaryCell">
          <div className="changeOrderSummaryLabel">Margin</div>
          <div className="changeOrderSummaryValue">
            {`${original ? pct(margin(original)) : DASH} → ${total ? pct(margin(total)) : DASH}`}
          </div>
        </div>
      )}
    </div>
  );
};

export default SummaryBar;
